import React, { useState, useEffect } from "react";
import axios from "axios";

import {
    Box,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    Divider,
    // ListItemIcon,
    // Table,
    // TableBody,
    // TableCell,
    // TableContainer,
    // TableHead,
    Autocomplete, Checkbox,
    Chip,
    // TableRow,
    Snackbar, CircularProgress, Select
} from "@mui/material";

import {

    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Avatar
} from "@mui/material";
import { Link, ArrowDropDown, Close } from "@mui/icons-material";
import ProfileIcon from '../../../src/assets/Icons/profile_temp.svg'
// import ProfileIconOne from '../../../src/assets/Icons/profile_temp1.svg'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import FileCopyIcon from "@mui/icons-material/FileCopy";
// import PeopleIcon from "@mui/icons-material/People";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import { useUser } from '../../hooks/Authorize';
import { useTheme } from "../../style/theme";

const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
};
function SharingDialog({ openModal, handleCloseModal, item, setClikkleItems, setShowProcessingSnackbar, setProcessingMessage }) {
    const platformUser = JSON.parse(localStorage.getItem("user"));
    // const [dropdownStates, setDropdownStates] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [permissions, setPermissions] = useState({});
    const [sharedWith, setSharedWith] = useState([]);
    const [newVisitor, setNewVisitor] = useState("");
    const [suggestedUsers, setSuggestedUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [anchorElGeneralAccess, setAnchorElGeneralAccess] = useState(null);
    const [generalAccess, setGeneralAccess] = useState(capitalizeFirstLetter(item.generalAccess) || 'Restricted');
    // const [generalAccess, setGeneralAccess] = useState(item.generalAccess?capitalizeFirstLetter(item.generalAccess) :'Restricted');

    // eslint-disable-next-line no-unused-vars
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [permission, setPermission] = useState("Viewer");
    const [notifyChecked, setNotifyChecked] = useState(true);
    const [message, setMessage] = useState("");
    const [sharedUsersProfile, setSharedUsersProfile] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const { mode } = useTheme();

    useEffect(() => {
        if (openModal) {
            setPermissions(
                item.sharedWith ? Object.fromEntries(item.sharedWith.map((user) => [user.userId, user.permissionType])) : {}
            );
            setSharedWith(item.sharedWith);
        }
        setSelectedUsers([])

        const sharedUserIds = item.sharedWith ? item.sharedWith.map(user => user.userId) : []; // Extract userIds

        axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/getUsers`, {
            params: { ids: sharedUserIds }
        })
            .then(response => {
                setSharedUsersProfile(response.data)
                // console.log(response.data)
            })
            .catch(error => console.error(error));

        setNewVisitor(""); // Reset input text
        // setSuggestedUsers([]); // Clear suggestions
        // setSelectedUsers([]); // Clear selected users

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal,]);


    const handleNewVisitorChange = (value) => {
        setNewVisitor(value);

        if (value.trim()) {
            setLoading(true);
            axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/getUsers?emailSubstring=${value}`)
                .then(response => {
                    setSuggestedUsers(response.data.filter(user => !selectedUsers.some(selected => selected._id === user._id)));
                    setLoading(false);
                })
                .catch(error => {
                    console.error("Error fetching users:", error);
                    setLoading(false);
                });
        } else {
            setSuggestedUsers([]);
        }
    };



    const handleSaveBtnClick = async () => {
        // console.log(selectedUsers);
        // console.log(message);
        // console.log(permission);
        // console.log(notifyChecked);
        setProcessingMessage("Saving Updates...")
        setShowProcessingSnackbar(true)
        const sharedUsers = selectedUsers.map(user => ({
            userId: user._id,
            email: user.email,
            permissionType: permission,


        }));

        try {
            const response = await axios.post(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/share`, {
                resourceId: item._id,
                sharedUsers: sharedUsers,
                notify: notifyChecked,
                message: message,
                userId: platformUser._id,
                frontendBaseUrl: window.location.origin
            });

            setClikkleItems((prevItems) =>
                prevItems.map((prevItem) =>
                    prevItem._id === response.data._id
                        ? { ...prevItem, sharedWith: response.data.sharedWith }
                        : prevItem
                )
            );

            handleCloseModal()

            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error sharing users:", error);
        }
        setShowProcessingSnackbar(false)
    };






    // const handleDeleteUser = (email) => {
    //     setSelectedUsers(selectedUsers.filter(user => user.email !== email));
    // };

    const handleRemoveSharedUser = async (userId) => {
        console.log(`Removing ${userId}`)

        setAnchorEl(null)
        setPermissions((prev) => {
            const updatedPermissions = { ...prev };
            delete updatedPermissions[userId]; // Remove user from permissions
            // call api
            return updatedPermissions;
        });
        setSharedWith((prev) => prev.filter(user => user.userId !== userId)); // Remove from sharedWith

        try {
            await axios.post(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/unshare`, {
                resourceId: item._id,
                userIds: [userId],
                userId: platformUser._id
            });

            setClikkleItems((prevItems) =>
                prevItems.map((prevItem) =>
                    prevItem._id === item._id
                        ? { ...prevItem, sharedWith: prevItem.sharedWith.filter(user => user.userId !== userId) }
                        : prevItem
                )
            );
        } catch (error) {
            console.error("Error updating shared users:", error);
        }


    };



    const handleGeneralAccessOpen = (event) => {
        setAnchorElGeneralAccess(event.currentTarget);
    };

    const handleGeneralAccessClose = async (accessType) => {
        if (accessType) {
            setGeneralAccess(accessType);
            setShowProcessingSnackbar(true)
            setProcessingMessage("Saving changes...");
            try {
                // Call the API to rename the item
                const response = await axios.put(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${item._id}`, {
                    id: item._id,
                    generalAccess: accessType,
                    userId: platformUser._id
                });
                setShowProcessingSnackbar(false)

                console.log("API Response:", response.data);
                // Update the items array after the API call is successful
                setClikkleItems((prevItems) =>
                    prevItems.map((prevItem) =>
                        prevItem._id === item._id ? { ...prevItem, generalAccess: accessType } : prevItem
                    )
                );
            } catch (error) {
                console.error("Error calling API:", error);
            }
        }
        setAnchorElGeneralAccess(null);
    };



    const handleMenuOpen = (event, userId) => {
        setAnchorEl(event.currentTarget);
        setSelectedUser(userId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedUser(null);
    };


    const updateSharedUsers = async (sharedUsers) => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/share`, {
                resourceId: item._id,
                sharedUsers: sharedUsers,
                userId: platformUser._id

            });

            setClikkleItems((prevItems) =>
                prevItems.map((prevItem) =>
                    prevItem._id === response.data._id
                        ? { ...prevItem, sharedWith: response.data.sharedWith }
                        : prevItem
                )
            );

        } catch (error) {
            console.error("Error updating shared users:", error);
        }
    };



    const handlePermissionChange = async (permission) => {
        console.log("selectedUser = ", selectedUser)
        if (selectedUser) {
            setPermissions((prev) => {
                const updatedPermissions = {
                    ...prev,
                    [selectedUser]: permission,
                };

                // Correctly derive sharedUsers inside the state update function
                const sharedUsers = Object.entries(updatedPermissions).map(([userId, permissionType]) => ({
                    userId,
                    permissionType
                }));
                updateSharedUsers(sharedUsers);
                return updatedPermissions;
            });
        }
        handleMenuClose();
    };






    return (
        <>

            <Dialog
                open={openModal}
                onClose={handleCloseModal}

                maxWidth="sm"


                fullWidth
                PaperProps={{
                    sx: {
                        // color: "#fff", // White text
                        // backgroundColor: "#191919", // Dark background
                        // background: "rgba(31, 31, 31, 1)",
                        background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

                        borderRadius: "12px",
                        padding: "10px",
                        maxHeight: "80vh"
                    },
                }}
            >

                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "18px"
                    }}
                >
                    Share '{item.name}'
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <IconButton onClick={handleCloseModal}>
                            <Close />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>

                            <Autocomplete
                                multiple
                                freeSolo
                                options={suggestedUsers}
                                getOptionLabel={(option) => option.email}
                                filterSelectedOptions
                                value={selectedUsers}
                                onChange={(event, newValue) => {
                                    setSelectedUsers(newValue);
                                    if (newValue.length > 0) setShowMessageBox(true);
                                    else setShowMessageBox(false);
                                }}
                                inputValue={newVisitor}
                                onInputChange={(event, value) => handleNewVisitorChange(value)}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip {...getTagProps({ index })} label={option.email} key={option.email} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Add people..."
                                        sx={{
                                            flex: selectedUsers.length > 0 ? "70%" : "100%",

                                            // border: "1px solid rgba(41, 41, 41, 1)",
                                            fontSize: "12px",

                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                padding: '1px 2px',
                                                paddingLeft: 1,
                                                fontSize: "14px",

                                                "& fieldset": {
                                                    borderColor: "#424242",
                                                },
                                            },
                                            "& .MuiInputBase-input": {
                                                padding: "8px 14px",
                                                color: "rgb(86, 86, 86)",
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: loading ? <CircularProgress size={20} /> : null,
                                        }}
                                    />
                                )}
                                sx={{ flex: selectedUsers.length > 0 ? "70%" : "100%" }}
                            />

                            {selectedUsers.length > 0 && (
                                <Select
                                    value={permission}
                                    onChange={(e) => setPermission(e.target.value)}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        width: "30%",
                                        "& .MuiSelect-select": {
                                            padding: "10px 10px",
                                            typography: "body2", // uses 14px font size from theme
                                        },
                                    }}
                                >
                                    <MenuItem value="Viewer">Viewer</MenuItem>
                                    <MenuItem value="Editor">Editor</MenuItem>
                                    <MenuItem value="Commenter">Commenter</MenuItem>
                                </Select>


                            )}
                        </Box>

                        {selectedUsers.length > 0 && (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, padding: 1 }}>


                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Checkbox checked={notifyChecked} onChange={(e) => setNotifyChecked(e.target.checked)} />
                                    <Typography>Notify people</Typography>
                                </Box>
                                <TextField
                                    placeholder="Message"
                                    multiline
                                    rows={3}
                                    variant="outlined"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    sx={{
                                        borderRadius: "8px",
                                        "& fieldset": {
                                            borderColor: "#424242",
                                        },
                                    }}
                                />

                            </Box>
                        )}
                    </Box>







                    {selectedUsers.length === 0 &&

                        (<>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                                Who has access
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    marginBottom: "20px",

                                }}
                            >
                                <Avatar sx={{ width: 32, height: 32 }} src={ProfileIcon} />
                                <Box>
                                    <Typography variant="body1">{platformUser.firstName} {" "}{platformUser.lastName}{" "}(you)</Typography>
                                    <Typography variant="body2" color="text.secondary">{item.owner}</Typography>
                                </Box>
                                <Typography sx={{ marginLeft: "auto" }}>Owner</Typography>
                            </Box>

                            {sharedWith && sharedWith.map((sharedUser) => {
                                const userProfile = sharedUsersProfile.find(user => user._id.toString() === sharedUser.userId.toString());

                                return (
                                    <>
                                        <Box
                                            key={sharedUser._id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <Avatar sx={{ width: 32, height: 32 }} src={ProfileIcon} />
                                            <Box>
                                                <Typography variant="body1">
                                                    {userProfile ? `${userProfile.firstName} ${userProfile.lastName}` : "Unknown User"}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">{userProfile?.email}</Typography>
                                            </Box>

                                            <Box sx={{ display: "flex", marginLeft: "auto", gap: 1 }} onClick={(e) => handleMenuOpen(e, sharedUser.userId)}>
                                                <Typography>
                                                    {permissions[sharedUser.userId] === "owner" ? "Owner" :
                                                        permissions[sharedUser.userId] === "Editor" ? "Editor" : "Viewer"}
                                                </Typography>
                                                <KeyboardArrowDownOutlinedIcon />
                                            </Box>
                                        </Box>
                                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                                            <MenuItem onClick={() => handlePermissionChange("Viewer")}>Viewer</MenuItem>
                                            <MenuItem onClick={() => handlePermissionChange("Editor")}>Editor</MenuItem>
                                            <MenuItem onClick={() => handlePermissionChange("Commenter")}>Commenter</MenuItem>
                                            <Divider />
                                            <MenuItem onClick={() => handleRemoveSharedUser(sharedUser.userId)}>Remove</MenuItem>
                                        </Menu>
                                    </>
                                );

                            })}


                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", }}>
                                General access
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    // border: "1px solid lightgray", 
                                    // borderRadius: "8px", 
                                    padding: "8px",
                                    marginBottom: "20px"
                                }}
                            >
                                {/* <HttpsOutlinedIcon sx={{ color: "lightgray" }} /> */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "rgb(59,59,59)",
                                        marginLeft: "-10px"
                                    }}
                                >
                                    <HttpsOutlinedIcon sx={{ color: "white" }} />
                                </Box>

                                <Box>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }} onClick={handleGeneralAccessOpen}>
                                        <Typography variant="body1">{generalAccess}</Typography>
                                        <Typography>
                                            <ArrowDropDown sx={{ color: "white", cursor: "pointer" }} />
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">
                                        {generalAccess === "Restricted"
                                            ? "Only people with access can open with the link"
                                            : "Anyone with the link can open"}
                                    </Typography>
                                </Box>

                                <Menu anchorEl={anchorElGeneralAccess} open={Boolean(anchorElGeneralAccess)} onClose={() => handleGeneralAccessClose()}>
                                    <MenuItem onClick={() => handleGeneralAccessClose("Restricted")}>Restricted</MenuItem>
                                    <MenuItem onClick={() => handleGeneralAccessClose("Anyone")}>Anyone</MenuItem>
                                </Menu>

                                <IconButton sx={{ marginLeft: "auto" }}>
                                    {/* <Search fontSize="small" /> */}
                                </IconButton>
                            </Box>
                        </>)
                    }

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 2 }}>

                        <Button
                            variant="outlined"
                            startIcon={<Link sx={{ transform: "rotate(135deg)" }} />}
                            sx={{
                                color: "rgb(55, 103, 177)",
                                borderRadius: "20px",
                                borderColor: "rgb(55, 103, 177)",
                                textTransform: "none"
                            }}
                            onClick={() => {
                                // var url = process.env.REACT_APP_DEVELOPMENT_SERVER + "/view"
                                var url = window.location.origin + "/view";
                                alert(window.location.origin)
                                if (item.type === 'file') {
                                    url += "?id=" + item._id;
                                } else {
                                    url += "?parentId=" + item._id;
                                }
                                navigator.clipboard.writeText(url);
                                setSnackbarOpen(true);
                            }}
                        >
                            Copy link
                        </Button>
                        <div>

                            <Button
                                onClick={handleCloseModal}

                                sx={{ width: "100px", backgroundColor: "", color: "white", borderRadius: "10px", marginRight: "5px" }}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                onClick={handleSaveBtnClick}
                                sx={{ width: "100px", backgroundColor: "rgb(55, 103, 177)", color: "white", borderRadius: "10px", }}
                            >
                                {selectedUsers.length === 0 ? "Done" : "Send"}
                            </Button>
                        </div>
                    </Box>



                </DialogContent>
            </Dialog>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message="Link copied to clipboard"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: "#191919",
                        background: "rgba(31, 31, 31, 1)",
                        color: '#fff',
                    }
                }}
            />
        </>
    )
}

export default SharingDialog